import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authSlice from './slices/authSlice';
import incidentSlice from './slices/incidentSlice';
import resourceSlice from './slices/resourceSlice';
import uiSlice from './slices/uiSlice';
import notificationSlice from './slices/notificationSlice';
import dispatchSlice from './slices/dispatchSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    incidents: incidentSlice,
    resources: resourceSlice,
    ui: uiSlice,
    notifications: notificationSlice,
    dispatch: dispatchSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
